import { RootState } from 'types'
import { Action } from 'redux/actions'

export default function reduce(state: RootState['followees'] = {}, action: Action): RootState['followees'] {
  switch (action.type) {
    case 'FOLLOWEE_ADD': {
      return {
        ...state,
        [action.payload.id]: action.payload,
      }
    }
    case 'FOLLOWEES_ADD': {
      const mergedFollowings = action.payload.reduce(
        (followings, following) => ({ ...followings, [following.id]: following }),
        {},
      )

      return {
        ...state,
        ...mergedFollowings,
      }
    }
    case 'FOLLOWEE_REMOVE': {
      const { id } = action.payload

      return {
        ...state,
        [id]: undefined,
      }
    }
    default:
      return state
  }
}
